import store from "@/store";

/* NOTE: on the main.js we get site-info */
export const findAttributeOnSiteInfo = (attributeName) => {
    /* NOTE: on the main.js we get site-info */
    const attribute = store.getters['SiteInfo/getSiteInfos'].filter(siteInfo => siteInfo.name === attributeName);
    if (attribute.length > 0) {
        let result = []
        for (let i = 0; i < attribute.length; i++) {
            result.push(attribute[i].value);
        }

        return result;
    }
    return false
}
